/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Helpers.EmailValidator = class EmailValidator {
  constructor(email) {
    this.email = email;
  }

  isValid() {
    const validEmailRegex = /^[A-Za-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.{1,1})+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/i
    return validEmailRegex.test(this.email);
  }
};
